import React from "react";
import "../loader/style.scss";

class IsLoading extends React.Component {
  render() {
    return (
      <div
        style={{
          display: "flex",
          width: "90vw",
          height: "90vh",
          alignItems: "center",
          margin: "auto",
          justifyContent: "center",
        }}
      >
        <div className="loader-08"></div>
      </div>
    );
  }
}

export default IsLoading;
